import Card from 'app/shared-components/Card'

import OrderChangeSummary from '../../Components/OrderChangeSummary'

import useStyles from './InternalOrdersChangeHistory.styles'

export default function InternalOrdersChangeHistory({
    id: orderNumber,
}: { id: string }) {
    const {
        classes,
    } = useStyles()

    return (
        <Card
            className={classes.root}
            title="Change History"
            titleClass={classes.title}
        >
            <OrderChangeSummary orderNumber={orderNumber} />
        </Card>
    )
}
